import React from "react";
import { SectionsAndCoursesUIProvider } from "./SectionsAndCoursesUIContext";
import { SectionsAndCoursesCard } from "./SectionsAndCoursesCard";

export function SectionsAndCoursesPage({ history, teacherId, term }) {
  return (
    <SectionsAndCoursesUIProvider>
      <SectionsAndCoursesCard 
        history={history}
        teacherId={teacherId}
        term={term}
      />
    </SectionsAndCoursesUIProvider>
 );
}